module.exports = __webpack_public_path__ + "static/media/team-ribbon.2679d04e.svg";